// Shared pieces of the card look, for surfaces that set their own `sx`.
// (Corner radius, hover lift and heading weight come from the theme.)

// A card with a coloured left edge, e.g. status on a task, "today" on a day column.
export const accentEdge = (color: string) => ({
    borderLeft: '4px solid',
    borderLeftColor: color,
});

// Neutral edge colour for things that aren't highlighted.
export const NEUTRAL_EDGE = 'grey.300';
